import { render, staticRenderFns } from "./Forge.vue?vue&type=template&id=369d1c32&scoped=true"
import script from "./Forge.vue?vue&type=script&lang=js"
export * from "./Forge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369d1c32",
  null
  
)

export default component.exports